import { Button as AIMEButton, Input as AIMEInput } from "tot-loft-component-library";


import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";

export default function VendorReferralsDetailsCommitted() {
  return (
    <RootWrapperVendorReferralsDetailsCommitted>
      <Header>
        <HeaderWrapper>
          <Left>
            <Logo>
              <Logo1>
                <Vector xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill="rgb(26, 32, 66)"
                    d="M8.30052 0C9.53868 0 10.6512 0.169308 11.6378 0.507912C12.6246 0.846504 13.4663 1.32532 14.1631 1.94434C14.8592 2.56392 15.391 3.31847 15.7585 4.20798C16.1261 5.09748 16.31 6.08434 16.3105 7.16854C16.3105 8.2519 16.1266 9.22882 15.7585 10.0993C15.3906 10.9698 14.8588 11.7099 14.1631 12.3197C13.4662 12.9288 12.6245 13.3979 11.6378 13.7268C10.6513 14.0557 9.5388 14.2202 8.30052 14.2205L4.58556 14.2205L4.58556 19.4442L0 19.4442L0 0L8.30052 0ZM8.01012 10.1865C9.15168 10.1865 10.0368 9.92087 10.6655 9.38938C11.2942 8.85791 11.6088 8.12755 11.6095 7.19832C11.6095 6.25078 11.2949 5.51077 10.6655 4.97832C10.0361 4.44588 9.15096 4.18014 8.01012 4.18112L4.58556 4.18112L4.58556 10.1865L8.01012 10.1865Z"
                  />
                </Vector>
                <Vector_0001 xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill="rgb(26, 32, 66)"
                    d="M7.19784 0C8.2032 0 9.11736 0.202801 9.94044 0.608401C10.7635 1.01399 11.4552 1.5944 12.0155 2.34965L12.0155 0.260148L16.3685 0.260148L16.3685 15.5834L12.0155 15.5834L12.0155 13.5241C11.5702 14.2399 10.9171 14.8058 10.0565 15.2217C9.19572 15.6377 8.24292 15.8456 7.19784 15.8455C6.153 15.8455 5.19036 15.6471 4.30992 15.2505C3.44604 14.8661 2.67048 14.3078 2.0316 13.6107C1.39296 12.9144 0.894841 12.0823 0.537241 11.1143C0.179641 10.1463 0.00048 9.08242 0 7.9225C0 6.74278 0.174121 5.66421 0.522601 4.68672C0.870961 3.70924 1.35936 2.8726 1.98792 2.17679C2.61732 1.47986 3.3768 0.942877 4.26624 0.565813C5.1558 0.188748 6.13296 0.000564 7.19784 0ZM8.2422 11.7818C8.80356 11.7818 9.31152 11.6852 9.76596 11.4921C10.2104 11.3059 10.6145 11.0352 10.9559 10.6949C11.2973 10.3515 11.5642 9.9415 11.7398 9.4903C11.923 9.02554 12.0148 8.51278 12.0155 7.9519C12.0155 6.81106 11.6671 5.8825 10.9705 5.16608C10.2739 4.44972 9.36444 4.09182 8.2422 4.09238C7.7004 4.09238 7.19736 4.18916 6.7332 4.38272C6.2832 4.56671 5.87376 4.83761 5.52852 5.17993C5.19 5.51867 4.92888 5.92486 4.74516 6.39862C4.56156 6.87226 4.46964 7.38982 4.46952 7.95106C4.46952 8.49286 4.56636 9.00082 4.75992 9.47482C4.95348 9.9487 5.2146 10.3551 5.54328 10.694C5.87208 11.0329 6.26868 11.2987 6.7332 11.4913C7.19772 11.6839 7.70064 11.7812 8.2422 11.7818Z"
                  />
                </Vector_0001>
                <Vector_0002 xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill="rgb(26, 32, 66)"
                    d="M7.1976 0.00125999C8.20368 0.00125999 9.11784 0.204049 9.94008 0.609649C10.7623 1.01524 11.454 1.59566 12.0151 2.35091L12.0151 0.261396L16.3687 0.261396L16.3687 15.5847L12.0151 15.5847L12.0151 13.5253C11.5698 14.2411 10.9169 14.8071 10.0561 15.223C9.19548 15.6389 8.24256 15.8469 7.1976 15.8467C6.15252 15.8467 5.19 15.6484 4.31016 15.2518C3.44628 14.8673 2.67084 14.3091 2.03184 13.612C1.39356 12.9156 0.8952 12.0835 0.53688 11.1155C0.17856 10.1476 -0.000359458 9.08366 5.42172e-07 7.92374C5.42172e-07 6.74402 0.174237 5.66545 0.522597 4.68797C0.871077 3.71048 1.35948 2.87384 1.98804 2.17804C2.61672 1.48126 3.37632 0.944052 4.26672 0.566424C5.15724 0.188808 6.13416 0 7.1976 0M8.24256 11.7825C8.8032 11.7825 9.31116 11.6859 9.76644 11.4927C10.2108 11.3063 10.6148 11.0356 10.9561 10.6955C11.2972 10.3521 11.5638 9.9419 11.7395 9.49094C11.9233 9.02618 12.0151 8.5133 12.0151 7.95254C12.0151 6.81171 11.6669 5.88302 10.9702 5.16671C10.2736 4.45034 9.36444 4.09244 8.24292 4.09301C7.70112 4.09301 7.19808 4.18979 6.73392 4.38335C6.28368 4.56697 5.87424 4.83792 5.52924 5.18056C5.18544 5.52718 4.91844 5.94242 4.74588 6.39926C4.56156 6.87374 4.46976 7.3913 4.47024 7.9517C4.47024 8.4935 4.56684 9.00134 4.76004 9.47534C4.95312 9.94934 5.21448 10.3558 5.54424 10.6947C5.87268 11.0335 6.26928 11.2993 6.73392 11.4918C7.19856 11.6844 7.70112 11.7819 8.24256 11.7825Z"
                  />
                </Vector_0002>
                <Vector_0003 xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill="rgb(26, 32, 66)"
                    d="M0 0.291192L4.3536 0.291192L4.3536 3.04804C4.99188 2.02301 5.7996 1.25874 6.77664 0.755244C7.75368 0.251748 8.80332 0 9.92556 0L9.92556 4.29629C9.11268 4.27714 8.36784 4.35448 7.69092 4.52832C7.014 4.70216 6.42864 4.9679 5.93496 5.32553C5.44692 5.67727 5.049 6.13964 4.77396 6.67472C4.49424 7.21652 4.35444 7.85504 4.35444 8.59028L4.35444 15.6136L0 15.6136L0 0.291192Z"
                  />
                </Vector_0003>
                <Vector_0004 xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill="rgb(26, 32, 66)"
                    d="M6.96516 0L6.96516 4.35335L10.6218 4.35335L10.6218 7.83587L6.96516 7.83587L6.96516 14.1334C6.96516 14.9658 7.1586 15.5124 7.54524 15.7733C7.932 16.0342 8.66736 16.126 9.7512 16.0489C9.80892 16.0489 9.95448 16.0395 10.1866 16.02C10.4185 16.0005 10.5642 15.9906 10.6218 15.9906L10.6218 19.7056C10.3897 19.7437 10.061 19.7825 9.63588 19.8216C9.21072 19.8607 8.88204 19.8802 8.64984 19.8799C6.57876 20.0149 5.055 19.6617 4.07844 18.8203C3.102 17.9789 2.61348 16.6681 2.61288 14.8879L2.61288 7.83587L0 7.83587L0 4.35335L2.61168 4.35335L2.61168 0L6.96516 0Z"
                  />
                </Vector_0004>
                <Vector_0005 xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill="rgb(26, 32, 66)"
                    d="M0 0.290352L4.3536 0.290352L4.3536 2.32195C4.9728 1.58686 5.69821 1.01608 6.52981 0.609648C7.36141 0.20322 8.22301 0 9.11341 0C9.92581 0 10.6662 0.145104 11.3334 0.435312C11.985 0.714324 12.5694 1.12998 13.0458 1.65419C13.5198 2.17685 13.8918 2.79601 14.163 3.51168C14.4342 4.22734 14.5698 5.01097 14.5698 5.86259L14.5698 15.6137L10.2162 15.6137L10.2162 6.79066C10.2162 5.93998 9.9786 5.25329 9.5046 4.73076C9.0318 4.20824 8.397 3.94699 7.6038 3.94699C7.1718 3.94457 6.7458 4.03914 6.3558 4.2237C5.96856 4.40807 5.62273 4.66987 5.34001 4.99301C5.04157 5.33596 4.806 5.72881 4.64388 6.15358C4.46952 6.59842 4.3728 7.08214 4.3536 7.60474L4.3536 15.6147L0 15.6147L0 0.290352Z"
                  />
                </Vector_0005>
                <Vector_0006 xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill="rgb(26, 32, 66)"
                    d="M4.55641 9.11182C4.73041 10.0795 5.14201 10.839 5.79001 11.3901C6.43681 11.9413 7.2552 12.2169 8.2428 12.2172C8.9388 12.2172 9.54241 12.072 10.056 11.7818C10.5684 11.4917 10.9224 11.0853 11.1156 10.5631L15.4392 10.5631C14.994 12.2849 14.124 13.6003 12.828 14.5095C11.532 15.4188 9.94561 15.8733 8.06761 15.8731C6.88801 15.8731 5.79961 15.6798 4.80361 15.293C3.80641 14.9064 2.9556 14.3651 2.2488 13.6693C1.5432 12.9727 0.991202 12.1358 0.596402 11.1589C0.200402 10.182 0.0012 9.1129 0 7.95166C0 6.79078 0.193201 5.72202 0.580801 4.74524C0.967201 3.76846 1.50841 2.9316 2.20561 2.23469C2.90161 1.53818 3.73441 0.991608 4.70161 0.59496C5.67001 0.198324 6.7332 0 7.8948 0C8.958 0 9.94921 0.164544 10.8684 0.493632C11.7888 0.82272 12.5916 1.27727 13.2768 1.85728C13.9668 2.44151 14.5344 3.1567 14.946 3.96146C15.372 4.78412 15.6228 5.68853 15.7008 6.67474C15.7392 7.12006 15.7632 7.47322 15.7728 7.73434C15.7836 7.99546 15.7884 8.19382 15.7872 8.3293C15.7872 8.60038 15.7776 8.8615 15.7584 9.11266L4.55641 9.11182ZM11.376 6.52906C11.2788 5.65846 10.926 4.97644 10.3176 4.48301C9.70801 3.98958 8.9388 3.74286 8.01 3.74286C7.158 3.74286 6.432 3.98958 5.832 4.48301C5.2332 4.97644 4.8264 5.65846 4.614 6.52906L11.376 6.52906Z"
                  />
                </Vector_0006>
                <Vector_0007 xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill="rgb(26, 32, 66)"
                    d="M0 0.291192L4.3536 0.291192L4.3536 3.04804C4.992 2.02301 5.7996 1.25874 6.7764 0.755244C7.7532 0.251748 8.8032 0 9.9252 0L9.9252 4.29629C9.1128 4.27714 8.3676 4.35448 7.6908 4.52832C7.014 4.70216 6.4284 4.9679 5.9352 5.32553C5.4468 5.67727 5.0496 6.13964 4.7736 6.67472C4.494 7.21652 4.3536 7.85504 4.3536 8.59028L4.3536 15.6136L0 15.6136L0 0.291192Z"
                  />
                </Vector_0007>
                <Vector_0008 xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill="rgb(26, 32, 66)"
                    d="M4.37161 2.12768C4.37161 3.33419 3.4248 4.28118 2.1924 4.28118C0.973195 4.28118 0 3.33419 0 2.12768C0 0.946992 0.973195 0 2.1924 0C3.4236 0 4.37161 0.946992 4.37161 2.12768ZM0.544794 2.12768C0.544794 3.07468 1.2444 3.82699 2.2056 3.82699C3.1392 3.82699 3.82679 3.07447 3.82679 2.14027C3.82679 1.19328 3.1392 0.427764 2.1924 0.427764C1.2456 0.427764 0.544794 1.1935 0.544794 2.12768ZM1.854 3.24251L1.3608 3.24251L1.3608 1.11566C1.5564 1.07664 1.82879 1.05084 2.17919 1.05084C2.58119 1.05084 2.76361 1.11566 2.91841 1.2065C3.03601 1.29734 3.12599 1.466 3.12599 1.6735C3.12599 1.90699 2.94481 2.08867 2.68561 2.1665L2.68561 2.19356C2.89321 2.2714 3.0096 2.42706 3.0744 2.71259C3.1404 3.03692 3.18 3.16657 3.2304 3.2444L2.69881 3.2444C2.63401 3.16657 2.59439 2.97168 2.53079 2.72538C2.49239 2.49188 2.36281 2.38804 2.09041 2.38804L1.854 2.38804L1.854 3.24251ZM1.8672 2.036L2.10121 2.036C2.37361 2.036 2.59319 1.94518 2.59319 1.72468C2.59319 1.53 2.45161 1.40034 2.13961 1.40034C2.04841 1.39834 1.9572 1.40699 1.8672 1.42615L1.8672 2.036Z"
                  />
                </Vector_0008>
                <Group1>
                  <Image19 />
                </Group1>
              </Logo1>
            </Logo>
          </Left>
          <Middle>
            <NavLinks>
              <AIMEButton
                size="small"
                onClick={() => alert("Dashboard clicked")}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "row",
                  alignItems: "center",
                  flex: "none",
                  gap: "10px",
                  background: "rgb(255, 255, 255)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  boxSizing: "border-box",
                  padding: "8px",
                }}
              >
                <span
                  style={{
                    color: "rgb(33, 37, 67)",
                    textOverflow: "ellipsis",
                    fontSize: "16px",
                    fontFamily: "Montserrat, sans-serif",
                    fontWeight: "500",
                    lineHeight: "22px",
                    textAlign: "left",
                  }}
                >
                  Dashboard
                </span>
              </AIMEButton>

              <AIMEButton
                size="small"
                onClick={() => alert("Referrals clicked")}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "row",
                  alignItems: "center",
                  flex: "none",
                  gap: "10px",
                  background: "rgb(255, 255, 255)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  boxSizing: "border-box",
                  padding: "8px",
                }}
              >
                <span
                  style={{
                    color: "rgb(33, 37, 67)",
                    textOverflow: "ellipsis",
                    fontSize: "16px",
                    fontFamily: "Montserrat, sans-serif",
                    fontWeight: "500",
                    lineHeight: "22px",
                    textAlign: "left",
                  }}
                >
                  Referrals
                </span>
              </AIMEButton>

              <AIMEButton
                size="small"
                onClick={() => alert("Vendor Profile clicked")}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "row",
                  alignItems: "center",
                  flex: "none",
                  gap: "10px",
                  background: "rgb(255, 255, 255)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  boxSizing: "border-box",
                  padding: "8px",
                }}
              >
                <span
                  style={{
                    color: "rgb(33, 37, 67)",
                    textOverflow: "ellipsis",
                    fontSize: "16px",
                    fontFamily: "Montserrat, sans-serif",
                    fontWeight: "500",
                    lineHeight: "22px",
                    textAlign: "left",
                  }}
                >
                  Vendor Profile
                </span>
              </AIMEButton>
            </NavLinks>
          </Middle>
          <PrtnrDropdown>
            <Button>
              <Image>
                <Image_0001 />
              </Image>
              <JamesD>Nesti</JamesD>
              <ChevronUp>chevron-up</ChevronUp>
            </Button>
          </PrtnrDropdown>
        </HeaderWrapper>
      </Header>
      <Dashboard>
        <Wrapper>
          <DashboardHeader>
            <Frame1462>
              <LinkButton>
                <AIMEButton
                  size="small"
                  onClick={() => alert("Back clicked")}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "row",
                    alignItems: "center",
                    flex: "none",
                    gap: "4px",
                    borderRadius: "4px",
                    boxSizing: "border-box",
                    padding: "8px 12px",
                  }}
                >
                  <span
                    style={{
                      color: "rgb(100, 116, 139)",
                      textOverflow: "ellipsis",
                      fontSize: "14px",
                      fontFamily: "Montserrat, sans-serif",
                      fontWeight: "600",
                      lineHeight: "140%",
                      textAlign: "left",
                    }}
                  >
                    Back
                  </span>
                </AIMEButton>
              </LinkButton>
              <WelcomeJames>Referrals Details</WelcomeJames>
            </Frame1462>
            <Frame1461 />
          </DashboardHeader>
          <StatusBars>
            <Frame1466>
              <Frame1468>
                <Frame1428>
                  <Handshake>handshake</Handshake>
                </Frame1428>
                <Frame1522>
                  <VerballyCommitted>Verbally committed</VerballyCommitted>
                  <TheVendorHasReachedAVerbalAgreementWithProspects>
                    The vendor has reached a verbal agreement with prospects.
                  </TheVendorHasReachedAVerbalAgreementWithProspects>
                  <Frame1436>
                    <Note>Note:</Note>
                    <LoremIpsumIsSimplyDummyTextOfThePrintingAndTypesettingIndustry>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry.
                    </LoremIpsumIsSimplyDummyTextOfThePrintingAndTypesettingIndustry>
                  </Frame1436>
                </Frame1522>
              </Frame1468>
              <Frame1470>
                <UpdatedAt3Apr2025>Updated at: 3-Apr-2025</UpdatedAt3Apr2025>

                <AIMEButton
                  size="small"
                  onClick={() => alert("Change Status clicked")}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "row",
                    alignItems: "center",
                    flex: "none",
                    gap: "8px",
                    borderRadius: "999px",
                    height: "36px",
                    background: "rgb(97, 98, 197)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    boxSizing: "border-box",
                    padding: "8px 16px",
                  }}
                >
                  <span
                    style={{
                      color: "white",
                      textOverflow: "ellipsis",
                      fontSize: "14px",
                      fontFamily: "Montserrat, sans-serif",
                      fontWeight: "600",
                      lineHeight: "140%",
                      textAlign: "left",
                    }}
                  >
                    Change Status
                  </span>
                </AIMEButton>
              </Frame1470>
            </Frame1466>
          </StatusBars>
          <Frame1485>
            <Frame1468_0001>
              <Frame1484>
                <ReferralsDetails>Referrals Details</ReferralsDetails>
                <Frame1539>
                  <SubmittedOn>Submitted on</SubmittedOn>
                  <Frame1551>
                    <_1Apr2025>1-Apr-2025</_1Apr2025>
                    <_1010Am>10:10am</_1010Am>
                  </Frame1551>
                </Frame1539>
              </Frame1484>
              <Frame1485_0001>
                <Frame1538>
                  <ContactPerson>Contact Person</ContactPerson>
                  <JohnnyDepp>Johnny Depp</JohnnyDepp>
                </Frame1538>
                <Frame1539_0001>
                  <ContactNumber>Contact Number</ContactNumber>
                  <_4412345677890>+44 123 4567 7890</_4412345677890>
                </Frame1539_0001>
                <Frame1538>
                  <EmailAddress>Email address</EmailAddress>
                  <JhonnydeppEmailCom>jhonnydepp@email.com</JhonnydeppEmailCom>
                </Frame1538>
              </Frame1485_0001>
              <Frame1476>
                <CompanyWebsite>Company Website</CompanyWebsite>
                <WwwGreenleafcafeCo>www.greenleafcafe.co</WwwGreenleafcafeCo>
              </Frame1476>
              <Frame1473>
                <Frame1470_0001>
                  <Frame1476>
                    <Sector>Sector</Sector>
                    <TechnologySoftwareSaaS>
                      Technology / Software / SaaS
                    </TechnologySoftwareSaaS>
                  </Frame1476>
                </Frame1470_0001>
                <Frame1471>
                  <Frame1476>
                    <Location>Location</Location>
                    <LondonUk>London, UK</LondonUk>
                  </Frame1476>
                </Frame1471>
              </Frame1473>
              <Frame1476>
                <DoesYourFriendHaveABudgetToWorkTo>
                  Does your friend have a budget to work to ?
                </DoesYourFriendHaveABudgetToWorkTo>
                <Unknown>Unknown</Unknown>
              </Frame1476>
              <Frame1476>
                <IsYouFriendADecisionMaker>
                  Is you friend a decision maker
                </IsYouFriendADecisionMaker>
                <Yes>Yes</Yes>
              </Frame1476>
              <Frame1476>
                <DoesYourFriendHaveAnUrgentProblemOrNeedToAddress>
                  Does your friend have an urgent problem or need to address?
                </DoesYourFriendHaveAnUrgentProblemOrNeedToAddress>
                <SelectedOption>[selected option]</SelectedOption>
              </Frame1476>
              <Frame1476>
                <InWhatTimeframeWillTheyNeedASolution>
                  In what timeframe will they need a solution?
                </InWhatTimeframeWillTheyNeedASolution>
                <SelectedOption>[selected option]</SelectedOption>
              </Frame1476>
              <Frame1483>
                <Frame1483_0001>
                  <PleaseShareAnyRelevantContextOfYourReferral>
                    Please share any relevant context of your referral
                  </PleaseShareAnyRelevantContextOfYourReferral>
                </Frame1483_0001>
                <Frame1472>
                  <AddSomeNotesHere>Add some notes here...</AddSomeNotesHere>
                </Frame1472>
              </Frame1483>
            </Frame1468_0001>
            <Right>
              <PRTNR.Input label="Expected Close Date" />

              <InternalNotes>
                <Frame1433>
                  <Frame1433_0001>
                    <InternalNotes_0001>Internal Notes</InternalNotes_0001>
                  </Frame1433_0001>
                </Frame1433>
                <PrtnrTextarea>
                  <GFieldsStacked_0001>
                    <AIMEInput type="text" placeholder="" />
                  </GFieldsStacked_0001>
                </PrtnrTextarea>
              </InternalNotes>
            </Right>
          </Frame1485>
          <Activity>
            <Frame1433_0002>
              <ReferralStatus>Activity</ReferralStatus>
            </Frame1433_0002>
            <ActivitesList>
              <Frame1428_0001
                src="https://figma-alpha-api.s3.us-west-2.amazonaws.com/images/92f3b856-7174-4d2e-b339-f3275370ccae"
                alt="icon"
              />
              <Frame1435>
                <Frame5>
                  <Frame1519>
                    <StatusChangedTo>Status changed to:</StatusChangedTo>
                    <VerballyCommitted_0001>
                      Verbally committed
                    </VerballyCommitted_0001>
                  </Frame1519>
                  <_3Apr2025>3-Apr-2025</_3Apr2025>
                </Frame5>
                <Frame1436>
                  <Note>Note:</Note>
                  <LoremIpsumIsSimplyDummyTextOfThePrintingAndTypesettingIndustry_0001>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry.
                  </LoremIpsumIsSimplyDummyTextOfThePrintingAndTypesettingIndustry_0001>
                </Frame1436>
              </Frame1435>
            </ActivitesList>
            <ActivitesList>
              <Frame1428_0001
                src="https://figma-alpha-api.s3.us-west-2.amazonaws.com/images/e56cce24-3109-46c3-b589-7b2b055776ca"
                alt="icon"
              />
              <Frame1435>
                <Frame5>
                  <Frame1519>
                    <StatusChangedTo>Status changed to:</StatusChangedTo>
                    <ProposalSent>Proposal Sent</ProposalSent>
                  </Frame1519>
                  <_2Apr2025>2-Apr-2025</_2Apr2025>
                </Frame5>
                <Frame1436>
                  <Note>Note:</Note>
                  <LoremIpsumIsSimplyDummyTextOfThePrintingAndTypesettingIndustry_0001>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry.
                  </LoremIpsumIsSimplyDummyTextOfThePrintingAndTypesettingIndustry_0001>
                </Frame1436>
              </Frame1435>
            </ActivitesList>
            <ActivitesList>
              <Frame1428_0001
                src="https://figma-alpha-api.s3.us-west-2.amazonaws.com/images/d8c66891-56c3-4d5b-ba2b-b38f0fccc90a"
                alt="icon"
              />
              <Frame1435>
                <Frame5>
                  <Frame1519>
                    <StatusChangedTo>Status changed to:</StatusChangedTo>
                    <OpportunityIdentified>
                      Opportunity identified
                    </OpportunityIdentified>
                  </Frame1519>
                  <_2Apr2025>2-Apr-2025</_2Apr2025>
                </Frame5>
                <Frame1436>
                  <Note>Note:</Note>
                  <LoremIpsumIsSimplyDummyTextOfThePrintingAndTypesettingIndustry_0001>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry.
                  </LoremIpsumIsSimplyDummyTextOfThePrintingAndTypesettingIndustry_0001>
                </Frame1436>
              </Frame1435>
            </ActivitesList>
            <ActivitesList>
              <Frame1428_0001
                src="https://figma-alpha-api.s3.us-west-2.amazonaws.com/images/f6b069be-a02d-464e-b0fa-43e49868fb17"
                alt="icon"
              />
              <Frame1435>
                <Frame5>
                  <Frame1519_0003>
                    <StatusChangedTo>Status changed to:</StatusChangedTo>
                    <LeadIdentified>Lead identified</LeadIdentified>
                  </Frame1519_0003>
                  <_1Apr2025_0001>1-Apr-2025</_1Apr2025_0001>
                </Frame5>
                <Frame1436>
                  <Note>Note:</Note>
                  <LoremIpsumIsSimplyDummyTextOfThePrintingAndTypesettingIndustry_0001>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry.
                  </LoremIpsumIsSimplyDummyTextOfThePrintingAndTypesettingIndustry_0001>
                </Frame1436>
              </Frame1435>
            </ActivitesList>
            <ActivitesList>
              <Frame1428_0001
                src="https://figma-alpha-api.s3.us-west-2.amazonaws.com/images/d8dcb7af-ce51-415d-a3c4-f0f9c92f1d86"
                alt="icon"
              />
              <Frame1435>
                <Frame5>
                  <Frame1519_0003>
                    <StatusChangedTo>Status changed to:</StatusChangedTo>
                    <LeadIdentified>Lead identified</LeadIdentified>
                  </Frame1519_0003>
                  <_1Apr2025_0001>1-Apr-2025</_1Apr2025_0001>
                </Frame5>
                <Frame1436>
                  <Note>Note:</Note>
                  <LoremIpsumIsSimplyDummyTextOfThePrintingAndTypesettingIndustry_0001>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry.
                  </LoremIpsumIsSimplyDummyTextOfThePrintingAndTypesettingIndustry_0001>
                </Frame1436>
              </Frame1435>
            </ActivitesList>
          </Activity>
        </Wrapper>
      </Dashboard>
      <Footer>
        <Section>
          <Wrapper_0001>
            <FooterLinks>
              <Left_0001>
                <Frame1483>
                  <Logo_0001>
                    <Logo1_0001>
                      <Vector_0009 xmlns="http://www.w3.org/2000/svg">
                        <path
                          fill="white"
                          d="M11.6799 0C13.4222 0 14.9877 0.239853 16.376 0.719542C17.7645 1.19921 18.9489 1.87753 19.9294 2.75448C20.909 3.63222 21.6572 4.70116 22.1744 5.9613C22.6916 7.22143 22.9504 8.61948 22.9511 10.1554C22.9511 11.6902 22.6922 13.0742 22.1744 14.3074C21.6566 15.5405 20.9083 16.5891 19.9294 17.4529C18.9487 18.3158 17.7643 18.9803 16.376 19.4463C14.9878 19.9123 13.4224 20.1453 11.6799 20.1457L6.4525 20.1457L6.4525 27.5459L0 27.5459L0 0L11.6799 0ZM11.2713 14.4309C12.8776 14.4309 14.1231 14.0546 15.0078 13.3016C15.8924 12.5487 16.3351 11.514 16.3362 10.1976C16.3362 8.85527 15.8934 7.80693 15.0078 7.05262C14.1221 6.29833 12.8766 5.92186 11.2713 5.92326L6.4525 5.92326L6.4525 14.4309L11.2713 14.4309Z"
                        />
                      </Vector_0009>
                      <Vector_0010 xmlns="http://www.w3.org/2000/svg">
                        <path
                          fill="white"
                          d="M10.1283 0C11.543 0 12.8294 0.287301 13.9875 0.861901C15.1457 1.43648 16.119 2.25874 16.9074 3.32867L16.9074 0.368543L23.0327 0.368543L23.0327 22.0765L16.9074 22.0765L16.9074 19.1591C16.2808 20.1732 15.3619 20.9749 14.1508 21.5641C12.9396 22.1533 11.5989 22.448 10.1283 22.4478C8.6581 22.4478 7.30353 22.1668 6.06463 21.6049C4.84904 21.0602 3.75773 20.2694 2.85874 19.2819C1.96008 18.2954 1.25916 17.1166 0.75597 15.7452C0.252778 14.374 0.000675425 12.8668 0 11.2235C0 9.55227 0.245012 8.02429 0.73537 6.63952C1.22556 5.25475 1.9128 4.06951 2.79727 3.08378C3.68292 2.09647 4.75161 1.33574 6.00317 0.801568C7.2549 0.267394 8.6299 0.000799 10.1283 0ZM11.5979 16.6909C12.3878 16.6909 13.1026 16.5541 13.742 16.2805C14.3675 16.0167 14.936 15.6332 15.4164 15.151C15.8968 14.6647 16.2723 14.0838 16.5195 13.4446C16.7772 12.7862 16.9064 12.0598 16.9074 11.2652C16.9074 9.649 16.4172 8.33354 15.437 7.31862C14.4568 6.30377 13.177 5.79675 11.5979 5.79754C10.8355 5.79754 10.1277 5.93465 9.47452 6.20886C8.84131 6.4695 8.26517 6.85328 7.77937 7.33824C7.30302 7.81811 6.9356 8.39355 6.67708 9.06471C6.41873 9.7357 6.28938 10.4689 6.28921 11.264C6.28921 12.0315 6.42548 12.7512 6.69785 13.4227C6.97021 14.094 7.33764 14.6698 7.80014 15.1499C8.26281 15.6299 8.82088 16.0065 9.47452 16.2793C10.1282 16.5522 10.8358 16.6901 11.5979 16.6909Z"
                        />
                      </Vector_0010>
                      <Vector_0011 xmlns="http://www.w3.org/2000/svg">
                        <path
                          fill="white"
                          d="M10.128 0.00178499C11.5437 0.00178499 12.83 0.289069 13.987 0.863669C15.144 1.43825 16.1173 2.26052 16.9069 3.33045L16.9069 0.370311L23.033 0.370311L23.033 22.0783L16.9069 22.0783L16.9069 19.1609C16.2803 20.175 15.3615 20.9767 14.1503 21.5659C12.9393 22.1551 11.5984 22.4497 10.128 22.4496C8.65742 22.4496 7.30303 22.1685 6.06498 21.6067C4.84938 21.062 3.75823 20.2712 2.85907 19.2836C1.96093 18.2971 1.25967 17.1184 0.755462 15.747C0.251257 14.3757 -0.000505805 12.8685 7.62908e-07 11.2253C7.62908e-07 9.55403 0.245175 8.02606 0.735364 6.64129C1.22572 5.25652 1.91297 4.07128 2.79744 3.08555C3.68208 2.09845 4.75094 1.33741 6.00385 0.802434C7.25693 0.267478 8.63159 0 10.128 0M11.5984 16.6918C12.3873 16.6918 13.1021 16.555 13.7427 16.2813C14.368 16.0173 14.9365 15.6337 15.4167 15.152C15.8966 14.6654 16.2718 14.0844 16.519 13.4455C16.7777 12.7871 16.9069 12.0605 16.9069 11.2661C16.9069 9.64991 16.4169 8.33428 15.4365 7.3195C14.4563 6.30465 13.177 5.79763 11.5989 5.79843C10.8365 5.79843 10.1287 5.93553 9.47553 6.20974C8.84199 6.46988 8.26585 6.85372 7.78038 7.33912C7.29661 7.83017 6.9209 8.41843 6.67809 9.06562C6.41873 9.7378 6.28955 10.471 6.29023 11.2649C6.29023 12.0325 6.42615 12.7519 6.69801 13.4234C6.9697 14.0949 7.33747 14.6707 7.80149 15.1508C8.26365 15.6309 8.82172 16.0074 9.47553 16.2801C10.1293 16.5529 10.8365 16.691 11.5984 16.6918Z"
                        />
                      </Vector_0011>
                      <Vector_0012 xmlns="http://www.w3.org/2000/svg">
                        <path
                          fill="white"
                          d="M0 0.412522L6.1261 0.412522L6.1261 4.31805C7.02425 2.86593 8.16082 1.78321 9.53565 1.06993C10.9105 0.356643 12.3875 0 13.9666 0L13.9666 6.08641C12.8228 6.05928 11.7747 6.16884 10.8222 6.41512C9.86965 6.6614 9.04597 7.03786 8.35129 7.5445C7.66455 8.0428 7.10463 8.69783 6.71761 9.45586C6.32401 10.2234 6.12729 11.128 6.12729 12.1696L6.12729 22.1193L0 22.1193L0 0.412522Z"
                        />
                      </Vector_0012>
                      <Vector_0013 xmlns="http://www.w3.org/2000/svg">
                        <path
                          fill="white"
                          d="M9.80091 0L9.80091 6.16724L14.9463 6.16724L14.9463 11.1008L9.80091 11.1008L9.80091 20.0223C9.80091 21.2016 10.0731 21.9759 10.6172 22.3455C11.1614 22.7151 12.1961 22.8451 13.7212 22.736C13.8025 22.736 14.0073 22.7226 14.3339 22.695C14.6603 22.6673 14.8653 22.6534 14.9463 22.6534L14.9463 27.9162C14.6197 27.9703 14.1572 28.0252 13.559 28.0806C12.9607 28.136 12.4982 28.1636 12.1715 28.1632C9.2572 28.3545 7.11306 27.854 5.73891 26.6621C4.36493 25.4701 3.67752 23.6132 3.67667 21.0912L3.67667 11.1008L0 11.1008L0 6.16724L3.67498 6.16724L3.67498 0L9.80091 0Z"
                        />
                      </Vector_0013>
                      <Vector_0014 xmlns="http://www.w3.org/2000/svg">
                        <path
                          fill="white"
                          d="M0 0.411332L6.1261 0.411332L6.1261 3.28943C6.9974 2.24805 8.01815 1.43944 9.18832 0.863668C10.3585 0.287895 11.5709 0 12.8238 0C13.9669 0 15.0088 0.205564 15.9476 0.616692C16.8645 1.01196 17.6868 1.6008 18.3572 2.34343C19.0242 3.08387 19.5476 3.96102 19.9293 4.97488C20.3109 5.98873 20.5017 7.09888 20.5017 8.30533L20.5017 22.1193L14.3756 22.1193L14.3756 9.6201C14.3756 8.41497 14.0412 7.44216 13.3743 6.70191C12.709 5.96168 11.8157 5.59157 10.6996 5.59157C10.0917 5.58814 9.49225 5.72211 8.94347 5.98357C8.39857 6.24476 7.91193 6.61565 7.51411 7.07343C7.09416 7.55927 6.7627 8.11582 6.53457 8.71757C6.28922 9.34776 6.15312 10.033 6.1261 10.7734L6.1261 22.1209L0 22.1209L0 0.411332Z"
                        />
                      </Vector_0014>
                      <Vector_0015 xmlns="http://www.w3.org/2000/svg">
                        <path
                          fill="white"
                          d="M6.41147 12.9084C6.65631 14.2793 7.23549 15.3552 8.14731 16.136C9.05745 16.9168 10.209 17.3073 11.5987 17.3077C12.5781 17.3077 13.4274 17.102 14.1501 16.6909C14.8712 16.2798 15.3693 15.7042 15.6411 14.9644L21.725 14.9644C21.0986 17.4035 19.8744 19.2671 18.0507 20.5552C16.2271 21.8433 13.9948 22.4872 11.3522 22.4869C9.69235 22.4869 8.16082 22.213 6.75932 21.6651C5.35612 21.1174 4.15893 20.3505 3.16436 19.3648C2.17149 18.378 1.39475 17.1924 0.839217 15.8084C0.281992 14.4245 0.00168856 12.9099 0 11.2648C0 9.62027 0.27186 8.10619 0.817265 6.72243C1.36098 5.33864 2.12253 4.1531 3.10358 3.16581C4.08295 2.17909 5.25481 1.40478 6.61579 0.84286C7.97846 0.280959 9.47452 0 11.109 0C12.6051 0 13.9999 0.233104 15.2933 0.699312C16.5884 1.16552 17.7181 1.80946 18.6822 2.63114C19.6532 3.4588 20.4518 4.47199 21.031 5.61207C21.6305 6.77751 21.9834 8.05875 22.0931 9.45588C22.1472 10.0867 22.1809 10.5871 22.1944 10.957C22.2096 11.3269 22.2164 11.6079 22.2147 11.7998C22.2147 12.1839 22.2012 12.5538 22.1742 12.9096L6.41147 12.9084ZM16.0076 9.2495C15.8708 8.01615 15.3744 7.04995 14.5183 6.35093C13.6605 5.6519 12.5781 5.30238 11.2711 5.30238C10.0723 5.30238 9.05069 5.6519 8.20641 6.35093C7.36381 7.04995 6.79139 8.01615 6.49252 9.2495L16.0076 9.2495Z"
                        />
                      </Vector_0015>
                      <Vector_0016 xmlns="http://www.w3.org/2000/svg">
                        <path
                          fill="white"
                          d="M0 0.412522L6.1261 0.412522L6.1261 4.31805C7.02441 2.86593 8.16082 1.78321 9.53531 1.06993C10.9098 0.356643 12.3873 0 13.9661 0L13.9661 6.08641C12.8229 6.05928 11.7743 6.16884 10.822 6.41512C9.86963 6.6614 9.04562 7.03786 8.35162 7.5445C7.66438 8.0428 7.10546 8.69783 6.71709 9.45586C6.32366 10.2234 6.1261 11.128 6.1261 12.1696L6.1261 22.1193L0 22.1193L0 0.412522Z"
                        />
                      </Vector_0016>
                      <Vector_0017 xmlns="http://www.w3.org/2000/svg">
                        <path
                          fill="white"
                          d="M6.15143 3.01422C6.15143 4.72343 4.81914 6.06501 3.08499 6.06501C1.36941 6.06501 0 4.72343 0 3.01422C0 1.34157 1.36941 0 3.08499 0C4.81745 0 6.15143 1.34157 6.15143 3.01422ZM0.766597 3.01422C0.766597 4.35579 1.75103 5.42157 3.10357 5.42157C4.41727 5.42157 5.38481 4.3555 5.38481 3.03205C5.38481 1.69048 4.41726 0.605999 3.08499 0.605999C1.75272 0.605999 0.766597 1.69079 0.766597 3.01422ZM2.60882 4.59355L1.91483 4.59355L1.91483 1.58052C2.19007 1.52524 2.57335 1.48869 3.06641 1.48869C3.63208 1.48869 3.88876 1.58052 4.10659 1.70921C4.27207 1.8379 4.39869 2.07684 4.39869 2.37079C4.39869 2.70157 4.14373 2.95895 3.77901 3.06921L3.77901 3.10755C4.07113 3.21781 4.2349 3.43833 4.32608 3.84283C4.41895 4.30231 4.47468 4.48598 4.5456 4.59624L3.79758 4.59624C3.7064 4.48598 3.65065 4.20988 3.56116 3.86095C3.50713 3.53017 3.32478 3.38305 2.94148 3.38305L2.60882 3.38305L2.60882 4.59355ZM2.6274 2.88434L2.95668 2.88434C3.33998 2.88434 3.64897 2.75567 3.64897 2.44329C3.64897 2.1675 3.44973 1.98382 3.01071 1.98382C2.88238 1.98098 2.75404 1.99323 2.6274 2.02038L2.6274 2.88434Z"
                        />
                      </Vector_0017>
                      <Vector_0018 xmlns="http://www.w3.org/2000/svg">
                        <path
                          fill="white"
                          d="M27.9982 1.11184C28.1769 1.93049 28.2666 2.76629 28.2657 3.60455C28.2657 10.0916 23.0178 15.3692 16.5756 15.3692C10.1334 15.3692 4.88915 10.0916 4.88915 3.60455C4.88915 3.22643 4.90627 2.85405 4.94052 2.48165C4.10953 1.64948 2.56118 0.624737 0.199262 1.03755C0.066484 1.88665 -0.00013993 2.74491 2.20653e-07 3.60455C2.20653e-07 12.8077 7.43351 20.2912 16.5745 20.2912C25.7155 20.2912 33.1492 12.8073 33.1492 3.60421C33.1516 2.39942 33.0219 1.19808 32.7622 0.0220006C32.5204 0.00714256 32.2879 -0.000183509 32.0646 3.49078e-06C30.0573 3.49078e-06 28.7716 0.570643 27.9982 1.11184Z"
                        />
                      </Vector_0018>
                      <Vector_0019 xmlns="http://www.w3.org/2000/svg">
                        <path
                          fill="white"
                          d="M5.19478 5.03591e-06C3.99278 0.000200384 2.82806 0.41996 1.89902 1.18777C0.969988 1.95558 0.334126 3.02393 0.0997372 4.21081C-0.134635 5.39769 0.0469864 6.62968 0.613667 7.69685C1.18035 8.76404 2.09702 9.60039 3.2075 10.0635C4.318 10.5265 5.5536 10.5876 6.70385 10.2363C7.8541 9.88501 8.84765 9.14309 9.51547 8.13695C10.1833 7.13079 10.4839 5.92265 10.3662 4.71835C10.2485 3.51407 9.71962 2.38813 8.86977 1.53238C8.38768 1.04578 7.81475 0.659896 7.18408 0.396918C6.5534 0.133939 5.8773 -0.000949987 5.19478 5.03591e-06Z"
                        />
                      </Vector_0019>
                      <Vector_0020 xmlns="http://www.w3.org/2000/svg">
                        <path
                          fill="white"
                          d="M24.9765 5.41979C25.0385 7.22558 24.2045 8.94699 22.9372 10.2247L22.2996 10.8651C21.0474 12.1259 19.3475 12.8519 17.5764 12.8267C17.53 12.8267 17.4835 12.8267 17.4373 12.8267C15.6661 12.8507 13.9678 12.1247 12.7141 10.8651L12.4983 10.6479C11.2289 9.36991 10.3956 7.65208 10.4528 5.84717C10.588 1.6468 4.92547 -1.62362 1.53771 1.98146C0.469668 2.99551 0.0097417 4.21225 0 5.4186L0 5.49765C0.0233211 8.32108 2.49595 11.0589 5.38982 10.9629C7.17433 10.9035 8.8732 11.7401 10.1373 13.0112L10.3598 13.2353C11.7072 14.5921 12.3156 16.4604 12.3044 18.379C12.2686 24.6232 22.7503 24.6229 22.7127 18.379C22.7012 16.4605 23.3089 14.5924 24.6562 13.2374L25.3031 12.5862C26.5661 11.3145 28.2653 10.4761 30.051 10.5299C34.2076 10.6556 37.4877 4.95496 33.8948 1.54872C32.8773 0.461853 31.6514 0 30.4367 0C27.621 0 24.8759 2.4852 24.9753 5.42158"
                        />
                      </Vector_0020>
                    </Logo1_0001>
                  </Logo_0001>
                </Frame1483>
                <Frame1483>
                  <PaartnerLimitedRegisteredInEnglandNo16078386>
                    Paartner Limited, registered in England No: 16078386.
                  </PaartnerLimitedRegisteredInEnglandNo16078386>
                  <VatRegistration3700001111>
                    VAT Registration: 370 000 1111
                  </VatRegistration3700001111>
                </Frame1483>
                <Frame1483>
                  <RegisteredOfficeUnit15RunwellHallFarmhouseHoeLaneRettendonEssexEnglandCm38Dq>
                    Registered office: Unit 15 Runwell Hall Farmhouse, Hoe Lane,
                    Rettendon, Essex, England, CM3 8DQ
                  </RegisteredOfficeUnit15RunwellHallFarmhouseHoeLaneRettendonEssexEnglandCm38Dq>
                </Frame1483>
              </Left_0001>
              <Right_0001>
                <MenuList>
                  <Legal>Legal</Legal>
                  <Frame1483>
                    <TermsConditions>Terms & Conditions</TermsConditions>
                    <PrivacyPolicy>Privacy Policy</PrivacyPolicy>
                    <CookiePolicy>Cookie Policy</CookiePolicy>
                    <ModernSlaveryStatement>
                      Modern Slavery Statement
                    </ModernSlaveryStatement>
                  </Frame1483>
                </MenuList>
                <MenuList_0001>
                  <Legal>Tools & Features</Legal>
                  <Frame1483>
                    <TermsConditions_0001>
                      Make a referral (Coming soon)
                    </TermsConditions_0001>
                    <PrivacyPolicy>Nominate a vendor</PrivacyPolicy>
                  </Frame1483>
                </MenuList_0001>
                <MenuList_0002>
                  <Legal>Support</Legal>
                  <Frame1483>
                    <TermsConditions>FAQ</TermsConditions>
                    <PrivacyPolicy>Contact Us</PrivacyPolicy>
                  </Frame1483>
                </MenuList_0002>
              </Right_0001>
            </FooterLinks>
          </Wrapper_0001>
        </Section>
        <Section_0001>
          <Section_0002>
            <Wrapper_0002>
              <Frame38_0001>
                <_2025PaartnerLimitedAllRightsReserved>
                  © 2025 Paartner Limited. All Rights Reserved
                </_2025PaartnerLimitedAllRightsReserved>
              </Frame38_0001>
            </Wrapper_0002>
          </Section_0002>
        </Section_0001>
      </Footer>
    </RootWrapperVendorReferralsDetailsCommitted>
  );
}

const RootWrapperVendorReferralsDetailsCommitted = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
`;

const Header = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  flex: 1;
  border-radius: 12px;
  width: 1200px;
  background: linear-gradient(
    -90deg,
    rgba(255, 255, 255, 0.85),
    rgba(255, 255, 255, 0.85)
  );
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px 16px;
  backdrop-filter: blur(10px);
`;

const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const Logo = styled.div`
  width: 165px;
  height: 24px;
  position: relative;
`;

const Logo1 = styled.div`
  width: 166px;
  height: 24px;
  overflow: hidden;
  position: absolute;
  left: 0px;
  top: 0px;
`;

const Vector = styled.svg`
  width: 16px;
  height: 19px;
  position: absolute;
  left: 34px;
  top: 2px;
  right: 116px;
  bottom: 2px;
`;

const Vector_0001 = styled.svg`
  width: 16px;
  height: 16px;
  position: absolute;
  left: 52px;
  top: 6px;
  right: 98px;
  bottom: 2px;
`;

const Vector_0002 = styled.svg`
  width: 16px;
  height: 16px;
  position: absolute;
  left: 70px;
  top: 6px;
  right: 79px;
  bottom: 2px;
`;

const Vector_0003 = styled.svg`
  width: 10px;
  height: 16px;
  position: absolute;
  left: 90px;
  top: 6px;
  right: 66px;
  bottom: 2px;
`;

const Vector_0004 = styled.svg`
  width: 11px;
  height: 20px;
  position: absolute;
  left: 101px;
  top: 2px;
  right: 54px;
  bottom: 2px;
`;

const Vector_0005 = styled.svg`
  width: 15px;
  height: 16px;
  position: absolute;
  left: 114px;
  top: 6px;
  right: 37px;
  bottom: 2px;
`;

const Vector_0006 = styled.svg`
  width: 16px;
  height: 16px;
  position: absolute;
  left: 131px;
  top: 6px;
  right: 19px;
  bottom: 2px;
`;

const Vector_0007 = styled.svg`
  width: 10px;
  height: 16px;
  position: absolute;
  left: 149px;
  top: 6px;
  right: 7px;
  bottom: 2px;
`;

const Vector_0008 = styled.svg`
  width: 4px;
  height: 4px;
  position: absolute;
  left: 161px;
  top: 6px;
  right: 1px;
  bottom: 14px;
`;

const Group1 = styled.div`
  width: 25px;
  height: 24px;
  position: absolute;
  left: 0px;
  top: 0px;
`;

const Image19 = styled.div`
  width: 25px;
  height: 24px;
  background: url(https://s3-alpha-sig.figma.com/img/4b35/a886/422bef44a2225fae3321414ad27d07ab?Expires=1749427200&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=i33cPzYFQHcGh27guJcKvhAwR6Dr~G6YmvSYO9TRDLGMGAzM6CFgh7bYlfO0T~8bsuEnrKqSFlYFkaB12zQTDmvBEIXWzAoGXgUvlKxS-Yo9zcTrC5U5MGznumIwfwMvTGITnjfOcY2xMnZc8TqP-FhlQjqt7UShedgFmWwjfMdhb~JWvok2T4-rA42H9nhYksRGE6qhPrIgLrWQAKPu0IYQP04AM60shoJSGl1oADynJbcUai9f2m7Jli-3Gh3qjGfWnQuDhYmBlMc7gwqD29h-CWv3PryINnlkmLht7HycXbkTbi6QBWRkCW60yX8cCVfw8uwu6xYeGxXbj19d2Q__);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: absolute;
  top: 0px;
  right: 0px;
`;

const Middle = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  flex: 1;
  gap: 8px;
  width: 868px;
  box-sizing: border-box;
`;

const NavLinks = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const ButtonsApp = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 10px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 8px;
`;

const ButtonLabel = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 22px;
  text-align: left;
`;

const PrtnrDropdown = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const Button = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  border-radius: 999px;
  background: rgb(226, 232, 240);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding-bottom: 4px;
  padding-top: 4px;
  padding-left: 4px;
  padding-right: 16px;
`;

const Image = styled.div`
  width: 40px;
  height: 40px;
  position: relative;
`;

const Image_0001 = styled.div`
  background: url(https://s3-alpha-sig.figma.com/img/26eb/10bc/0215ce531a4897da371d515ad69851ad?Expires=1749427200&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=M15H208j5Zl6hRPEvKa8bRve2s9du3SyHXyfkQVN0ystDE~6S0JNaDN6aUE-ARfeO1ytqt2TCnmVzc2y5Ex~Mkc7QJTYU9xktbDPCv30Fw2TAqrgE-AcD2iQR3vgirQ9OJ8D-ijCiHsWNdcLYPsxYcqtMfaP3hFl4t0AGzXcR1sdtUlsU2gau~HiVSEnIKJxp44yDSYZirpTYsXTMrfq3kv9cF2ny~75z9M4AqrkNdK9MoPmo-0~8ebloTDVppSpKJDX9fIXI9nGy4CEWXV2OR~wIAqiJQ84-wQHcyDJEFLOTClmRtfGZmYme4ZaIdju6ZajYTrK-~FuIXh7sOkhlw__);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  border-radius: 40px / 40px;
  position: absolute;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
`;

const JamesD = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  line-height: 110%;
  text-align: left;
`;

const ChevronUp = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: "Font Awesome 6 Pro", sans-serif;
  font-weight: 400;
  text-align: left;
`;

const Dashboard = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  background: rgb(241, 245, 249);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 0px 60px;
  flex-shrink: 0;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  gap: 24px;
  width: 1200px;
  box-sizing: border-box;
  padding: 0px 0px 32px;
`;

const DashboardHeader = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  width: 1200px;
  box-sizing: border-box;
  padding: 16px 0px;
`;

const Frame1462 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  width: 767px;
  box-sizing: border-box;
`;

const LinkButton = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const GButtons = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 4px;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 8px 12px;
`;

const IconArrowNarrowLeft = styled.img`
  width: 16px;
  height: 16px;
  object-fit: cover;
`;

const ButtonLabel_0003 = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  line-height: 140%;
  text-align: left;
`;

const WelcomeJames = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 48px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  letter-spacing: -1px;
  text-align: center;
`;

const Frame1461 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const StatusBars = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1466 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  border-radius: 16px;
  align-self: stretch;
  background: linear-gradient(
    -90deg,
    rgba(244, 186, 52, 0.1),
    rgba(244, 186, 52, 0.1)
  );
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px 24px;
  flex-shrink: 0;
`;

const Frame1468 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: 16px;
  width: 824px;
  box-sizing: border-box;
`;

const Frame1428 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  gap: 4px;
  border-radius: 999px;
  width: 48px;
  height: 48px;
  background: linear-gradient(
    -90deg,
    rgba(244, 186, 52, 0.1),
    rgba(244, 186, 52, 0.1)
  );
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
`;

const Handshake = styled.span`
  color: rgb(244, 186, 52);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: "Font Awesome 6 Pro", sans-serif;
  font-weight: 400;
  line-height: 160%;
  text-align: center;
`;

const Frame1522 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  width: 760px;
  box-sizing: border-box;
`;

const VerballyCommitted = styled.span`
  color: rgb(244, 186, 52);
  text-overflow: ellipsis;
  font-size: 20px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  line-height: 160%;
  text-align: left;
`;

const TheVendorHasReachedAVerbalAgreementWithProspects = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1436 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Note = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const LoremIpsumIsSimplyDummyTextOfThePrintingAndTypesettingIndustry = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 713px;
  flex: 1;
`;

const Frame1470 = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const UpdatedAt3Apr2025 = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const ButtonsApp_0003 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  border-radius: 999px;
  height: 36px;
  background: rgb(97, 98, 197);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 8px 16px;
`;

const ButtonLabel_0004 = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  line-height: 140%;
  text-align: left;
`;

const Frame1485 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  width: 1200px;
  box-sizing: border-box;
`;

const Frame1468_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  width: 829px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
`;

const Frame1484 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const ReferralsDetails = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 389px;
  min-height: 29px;
  flex: 1;
`;

const Frame1539 = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: 8px;
  width: 387px;
  box-sizing: border-box;
`;

const SubmittedOn = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const Frame1551 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const _1Apr2025 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const _1010Am = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const Frame1485_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 8px 16px;
  flex-shrink: 0;
`;

const Frame1538 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: 1;
  width: 239px;
  box-sizing: border-box;
`;

const ContactPerson = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  min-height: 29px;
  align-self: stretch;
  flex-shrink: 0;
`;

const JohnnyDepp = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1539_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: 1;
  width: 239px;
  box-sizing: border-box;
`;

const ContactNumber = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  min-height: 29px;
  align-self: stretch;
  flex-shrink: 0;
`;

const _4412345677890 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const EmailAddress = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  min-height: 29px;
  align-self: stretch;
  flex-shrink: 0;
`;

const JhonnydeppEmailCom = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1476 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const CompanyWebsite = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const WwwGreenleafcafeCo = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1473 = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1470_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 24px;
  width: 391px;
  box-sizing: border-box;
`;

const Sector = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const TechnologySoftwareSaaS = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1471 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 24px;
  width: 391px;
  box-sizing: border-box;
`;

const Location = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const LondonUk = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const DoesYourFriendHaveABudgetToWorkTo = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Unknown = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const IsYouFriendADecisionMaker = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Yes = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const DoesYourFriendHaveAnUrgentProblemOrNeedToAddress = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const SelectedOption = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const InWhatTimeframeWillTheyNeedASolution = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1483 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1483_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const PleaseShareAnyRelevantContextOfYourReferral = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 781px;
  flex: 1;
`;

const Frame1472 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  border-radius: 8px;
  align-self: stretch;
  height: 186px;
  background: rgb(243, 244, 251);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px;
  flex-shrink: 0;
`;

const AddSomeNotesHere = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 299px;
`;

const Right = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 8px;
  width: 347px;
  box-sizing: border-box;
`;

const PrtnrInput = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const GFieldsStacked = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame5 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const FieldLabel = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const Field = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  border: solid 1px rgb(224, 228, 244);
  border-radius: 8px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 8px 16px;
  flex-shrink: 0;
`;

const Placeholder = styled.span`
  color: black;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 291px;
  flex: 1;
`;

const IconCaretdown = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-end;
  flex: none;
  gap: 8px;
  width: 16px;
  height: 16px;
  box-sizing: border-box;
`;

const CaretDown = styled.div`
  width: 9px;
  height: 5px;
  background: url(https://s3-alpha-sig.figma.com/img/46bf/ca2f/25eedd208bc5c58011128405095de699?Expires=1749427200&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=TI2quGmm0PogRcGZ5Ijn0sZ1wQvgIqfLM607VoItwHpXkWA3z7dsydcUFmLWtPem42EciVHHw-Q6522f3Xn4WY-PUgbcQHq-s3cYw2OzCHDbAAyrOpWCAk0JfPLeLA9NgugV8t7nqeZ7gJtu-WaccbThFtv54ZtwAt0Ma-22~olee3IvaGlWue9n~H9i5OMRpUVVBANZt4RTdi22GNhIfvP-DMsU7bL9ai~GF59xW1qlXZ7G4rgh94CQdelXf5iVzBh7I3z6NIlTfRMId46-Ayc~nDWViPOJamuEAQkMkK9rhUEGI1K6~HrChdAhRAbG3J~62X8mxmvOvsp6d3af7w__);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;

const InternalNotes = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  height: 282px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const Frame1433 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1433_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
  width: 299px;
  box-sizing: border-box;
`;

const InternalNotes_0001 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 301px;
  min-height: 29px;
  flex: 1;
`;

const PrtnrTextarea = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  height: 186px;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const GFieldsStacked_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  align-self: stretch;
  height: 186px;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Field_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: 8px;
  border: solid 1px rgb(224, 228, 244);
  border-radius: 8px;
  align-self: stretch;
  height: 186px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 8px 16px;
  flex-shrink: 0;
`;

const Placeholder_0001 = styled.span`
  color: rgb(179, 182, 195);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 268px;
  flex: 1;
`;

const Activity = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const Frame1433_0002 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const ReferralStatus = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 1152px;
  min-height: 29px;
  flex: 1;
`;

const ActivitesList = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  border: solid 1px rgba(136, 136, 136, 0.1);
  width: 1152px;
  box-sizing: border-box;
  padding: 0px 0px 16px;
`;

const Frame1428_0001 = styled.img`
  width: 32px;
  height: 32px;
  object-fit: cover;
`;

const Frame1435 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  width: 1112px;
  box-sizing: border-box;
`;

const Frame1519 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  width: 1041px;
  box-sizing: border-box;
`;

const StatusChangedTo = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const VerballyCommitted_0001 = styled.span`
  color: rgb(244, 186, 52);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const _3Apr2025 = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 14px;
  text-align: left;
`;

const LoremIpsumIsSimplyDummyTextOfThePrintingAndTypesettingIndustry_0001 = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 1065px;
  flex: 1;
`;

const ProposalSent = styled.span`
  color: rgb(244, 186, 52);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const _2Apr2025 = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 14px;
  text-align: left;
`;

const OpportunityIdentified = styled.span`
  color: rgb(89, 84, 222);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const Frame1519_0003 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  width: 1044px;
  box-sizing: border-box;
`;

const LeadIdentified = styled.span`
  color: rgb(89, 84, 222);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const _1Apr2025_0001 = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 14px;
  text-align: left;
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Section = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  background: linear-gradient(90deg, rgb(136, 203, 234), rgb(95, 95, 196));
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 60px;
  flex-shrink: 0;
`;

const Wrapper_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  width: 1200px;
  box-sizing: border-box;
`;

const FooterLinks = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  width: 1200px;
  box-sizing: border-box;
`;

const Left_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 32px;
  width: 588px;
  box-sizing: border-box;
  padding-right: 16px;
`;

const Logo_0001 = styled.div`
  width: 232px;
  height: 34px;
  position: relative;
`;

const Logo1_0001 = styled.div`
  overflow: hidden;
  position: absolute;
  left: 0px;
  top: 0px;
  right: -1px;
  bottom: 0px;
`;

const Vector_0009 = styled.svg`
  width: 23px;
  height: 28px;
  position: absolute;
  left: 47px;
  top: 3px;
  right: 163px;
  bottom: 3px;
`;

const Vector_0010 = styled.svg`
  width: 23px;
  height: 22px;
  position: absolute;
  left: 73px;
  top: 9px;
  right: 137px;
  bottom: 3px;
`;

const Vector_0011 = styled.svg`
  width: 23px;
  height: 22px;
  position: absolute;
  left: 99px;
  top: 9px;
  right: 111px;
  bottom: 3px;
`;

const Vector_0012 = styled.svg`
  width: 14px;
  height: 22px;
  position: absolute;
  left: 127px;
  top: 9px;
  right: 92px;
  bottom: 3px;
`;

const Vector_0013 = styled.svg`
  width: 15px;
  height: 28px;
  position: absolute;
  left: 142px;
  top: 3px;
  right: 76px;
  bottom: 3px;
`;

const Vector_0014 = styled.svg`
  width: 21px;
  height: 22px;
  position: absolute;
  left: 160px;
  top: 9px;
  right: 52px;
  bottom: 3px;
`;

const Vector_0015 = styled.svg`
  width: 22px;
  height: 22px;
  position: absolute;
  left: 184px;
  top: 9px;
  right: 27px;
  bottom: 3px;
`;

const Vector_0016 = styled.svg`
  width: 14px;
  height: 22px;
  position: absolute;
  left: 210px;
  top: 9px;
  right: 10px;
  bottom: 3px;
`;

const Vector_0017 = styled.svg`
  width: 6px;
  height: 6px;
  position: absolute;
  left: 226px;
  top: 9px;
  right: 1px;
  bottom: 19px;
`;

const Vector_0018 = styled.svg`
  width: 33px;
  height: 20px;
  position: absolute;
  left: 1px;
  top: 14px;
  right: 199px;
  bottom: 0px;
`;

const Vector_0019 = styled.svg`
  width: 10px;
  height: 10px;
  position: absolute;
  left: 13px;
  top: 0px;
  right: 210px;
  bottom: 24px;
`;

const Vector_0020 = styled.svg`
  width: 35px;
  height: 23px;
  position: absolute;
  left: 0px;
  top: 1px;
  right: 198px;
  bottom: 10px;
`;

const PaartnerLimitedRegisteredInEnglandNo16078386 = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: center;
`;

const VatRegistration3700001111 = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: center;
`;

const RegisteredOfficeUnit15RunwellHallFarmhouseHoeLaneRettendonEssexEnglandCm38Dq = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Right_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: flex-start;
  flex: 1;
  gap: 24px;
  width: 588px;
  box-sizing: border-box;
`;

const MenuList = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  width: 221px;
  box-sizing: border-box;
`;

const Legal = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const TermsConditions = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const PrivacyPolicy = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const CookiePolicy = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const ModernSlaveryStatement = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const MenuList_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 24px;
  width: 221px;
  box-sizing: border-box;
`;

const TermsConditions_0001 = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const MenuList_0002 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  box-sizing: border-box;
`;

const Section_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  background: rgb(33, 37, 67);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const Section_0002 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  padding: 0px 60px;
  flex-shrink: 0;
`;

const Wrapper_0002 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame38_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const _2025PaartnerLimitedAllRightsReserved = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;
